import { type ApiErrorResponse, HttpError } from "./http-error";

function isApiErrorResponse(data: unknown): data is ApiErrorResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "statusCode" in data &&
    typeof data.statusCode === "number" &&
    "code" in data &&
    typeof data.code === "string" &&
    "timestamp" in data &&
    typeof data.timestamp === "string"
  );
}

function extractMaybeMessage(err: unknown): string | undefined {
  if (err && typeof err === "object" && "message" in err) {
    return String(err.message);
  }
  return undefined;
}

/**
 * Validate AxiosError { ..., response: { data } }
 * @param err
 * @returns
 */
function extractMaybeResponse(err: unknown): unknown | undefined {
  if (
    err &&
    typeof err === "object" &&
    "response" in err &&
    err.response &&
    typeof err.response === "object" &&
    "data" in err.response
  ) {
    return err.response.data;
  }
  return undefined;
}

export function normalizeHttpError(err: unknown): HttpError {
  let apiErrorResponse: ApiErrorResponse | undefined;
  let unknownErrorResponse: unknown;

  const maybeResponse = extractMaybeResponse(err);
  const maybeMessage = extractMaybeMessage(err);

  if (maybeResponse && isApiErrorResponse(maybeResponse)) {
    apiErrorResponse = maybeResponse;
  } else if (maybeResponse) {
    unknownErrorResponse = maybeResponse;
  }

  const normalizedMessage =
    apiErrorResponse?.message ||
    maybeMessage ||
    "An unexpected error occurred.";

  return new HttpError({
    message: normalizedMessage,
    originalError: err,
    apiErrorResponse,
    unknownErrorResponse,
  });
}
